<div class="area content">
  <ng-content class="gap-16 radius-4" select="[slot=content]"></ng-content>
</div>
<div class="area action">
  <ng-content select="[slot=action]"></ng-content>
</div>
